import React from 'react';

const FloatingNotesButton = ({ onClick, hasNotes, setDisplayModal }) => (
    <button
        onClick={() => setDisplayModal(true)}
        style={{
            position: 'fixed',
            bottom: '16px',
            left: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 16px',
            background: 'white',
            color: '#4a86e8',
            border: '1px solid #4a86e8',
            borderRadius: '12px',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
            zIndex: 1000,
            ':hover': {
                background: 'rgba(74, 134, 232, 0.05)',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)'
            }
        }}
    >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4a86e8" strokeWidth="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            <line x1="9" y1="10" x2="15" y2="10" />
            {hasNotes && <line x1="9" y1="14" x2="15" y2="14" />}
        </svg>
        Notes {hasNotes && '(1)'}
    </button>
);

export default FloatingNotesButton; 